export const useShopZone = () => useState('shopZone', () => null);